import type {Context} from 'react'
import {createContext} from 'react'

import type {BuildTypeId, ProjectId} from '../../../../../types'
import {noop} from '../../../../../utils/empty'

export const HighlightContext: Context<Set<BuildTypeId>> = createContext(new Set())
type Ungrouped = {
  buildTypes: BuildTypeId[]
  projects: ProjectId[]
}
export type Grouping = {
  isGroupedComposite: (id: BuildTypeId) => boolean
  isGroupedProject: (id: ProjectId) => boolean
  getUngrouped(): Ungrouped
  groupComposite: (id: BuildTypeId, grouped: boolean) => unknown
  groupProject: (id: ProjectId, grouped: boolean) => unknown
}
export const GroupingContext = createContext<Grouping>({
  isGroupedComposite: () => false,
  isGroupedProject: () => false,
  getUngrouped: () => ({buildTypes: [], projects: []}),
  groupComposite: noop,
  groupProject: noop,
})
export const IsDependantContext = createContext<(buildTypeId: BuildTypeId) => boolean>(() => false)
